const MAX_STRING_SIZE = 40;
const formatText = text => {
  if (!text) {
    return undefined;
  }
  return text.substring(0, MAX_STRING_SIZE);
};
const formatPhone = phone => {
  if (!phone) {
    return undefined;
  }
  return formatText(phone.replace(/[^0-9]/g, ''));
};

/**
 * Returns chunks of 40 characters
 * @param {string} address - Client address.
 * @returns {Array}
 */
const splitAddress = address => {
  const pattern = new RegExp(`.{1,${MAX_STRING_SIZE}}(\\s|$)`, 'g');
  const match = address.match(pattern);
  if (!match || !match.length) {
    return [];
  }
  if (match.length > 2) {
    return [formatText(match.shift()), formatText(match.join(' '))];
  }
  return [formatText(match[0])];
};

export { formatPhone, formatText, splitAddress };
//# sourceMappingURL=PaymentUtils.js.map
